import { ValueOf } from '@xhgj/xh-jsutils'
import { customCreateEnum } from './enumArray'

export const invoiceTypeList = [
  {
    value: '20',
    label: '增值税电子专用票',
  },
  {
    value: '01',
    label: '增值税专用票',
  },
  {
    value: '31',
    label: '电子发票（增值税专用发票）',
  },
  {
    value: '04',
    label: '增值税普通发票',
  },
  {
    label: '增值税电子普通发票',
    value: '10',
  },
  {
    label: '电子发票（普通发票）',
    value: '32',
  },
] as const

export const invoiceTypeEnum = customCreateEnum(invoiceTypeList)

const supplierPayTypeList = [
  { value: 'T', label: '银行转账(含网银、转账支票、现金支票)' },
  { value: 'B', label: '银行汇票' },
  { value: 'F', label: '商业汇票' },
  { value: 'U', label: '备用金' },
  { value: 'S', label: '报销' },
  { value: 'H', label: '电建融信' },
  { value: 'I', label: '建信融通' },
  { value: 'J', label: '供应链金融（工银e信）' },
  { value: '5', label: '供应链金融（中企云链）' },
  { value: 'A', label: '支付宝' },
  { value: 'E', label: '现金支付' },
  { value: 'G', label: '银行保函' },
  { value: 'K', label: '走流程' },
  { value: 'Z', label: '其它' },
] as const

export const supplierPayTypeEnum = customCreateEnum(supplierPayTypeList)

const paymentStatusList = [
  { label: '驳回', value: '1' },
  { label: '审核中', value: '2' },
  { label: '已放弃', value: '5' },
  { label: '付款中', value: '3' },
  { label: '付款完成', value: '4' },
  { label: '付款中（有退款）', value: '6' },
  { label: '付款完成（有退款）', value: '7' },
  { label: '退款完成', value: '8' },
] as const
export const paymentStatusEnum = customCreateEnum(paymentStatusList)

// @ApiModelProperty("发票性质 RED/BLUE")
// private InvoiceNatureEnum invoiceNature;
const invoiceNatureList = [
  {
    label: '红票',
    value: 'RED',
  },
  {
    label: '蓝票',
    value: 'BLUE',
  },
] as const

export type InvoiceNatureValue = ValueOf<typeof invoiceNatureList>
export const invoiceNatureEnum = customCreateEnum(invoiceNatureList)

// 红票开票状态
const redInvoiceStateList = [
  { label: '审核中', value: '1' },
  { label: '暂存', value: '2' },
  { label: '已开票', value: '3' },
  { label: '驳回', value: '4' },
  { label: '未开票', value: '5' },
] as const

export const redInvoiceStateEnum = customCreateEnum(redInvoiceStateList)

// 单选框，值范围：咸亨国际科技股份有限公司、万聚国际（杭州）供应链有限公司

const titleOfTheContractList = [
  { label: '咸亨国际科技股份有限公司', value: '1000' },
  {
    label: '万聚国际（杭州）供应链有限公司',
    value: '1025',
  },
] as const

export const titleOfTheContractEnum = customCreateEnum(titleOfTheContractList)
import { ValueOf } from '@xhgj/xh-jsutils'
import { customCreateEnum } from './enumArray'

export const invoiceTypeList = [
  {
    value: '20',
    label: '增值税电子专用票',
  },
  {
    value: '01',
    label: '增值税专用票',
  },
  {
    value: '31',
    label: '电子发票（增值税专用发票）',
  },
  {
    value: '04',
    label: '增值税普通发票',
  },
  {
    label: '增值税电子普通发票',
    value: '10',
  },
  {
    label: '电子发票（普通发票）',
    value: '32',
  },
] as const

export const invoiceTypeEnum = customCreateEnum(invoiceTypeList)

const supplierPayTypeList = [
  { value: 'T', label: '银行转账(含网银、转账支票、现金支票)' },
  { value: 'B', label: '银行汇票' },
  { value: 'F', label: '商业汇票' },
  { value: 'U', label: '备用金' },
  { value: 'S', label: '报销' },
  { value: 'H', label: '电建融信' },
  { value: 'I', label: '建信融通' },
  { value: 'J', label: '供应链金融（工银e信）' },
  { value: '5', label: '供应链金融（中企云链）' },
  { value: 'A', label: '支付宝' },
  { value: 'E', label: '现金支付' },
  { value: 'G', label: '银行保函' },
  { value: 'K', label: '走流程' },
  { value: 'Z', label: '其它' },
] as const

export const supplierPayTypeEnum = customCreateEnum(supplierPayTypeList)

const paymentStatusList = [
  { label: '驳回', value: '1' },
  { label: '审核中', value: '2' },
  { label: '已放弃', value: '5' },
  { label: '付款中', value: '3' },
  { label: '付款完成', value: '4' },
  { label: '付款中（有退款）', value: '6' },
  { label: '付款完成（有退款）', value: '7' },
  { label: '退款完成', value: '8' },
] as const
export const paymentStatusEnum = customCreateEnum(paymentStatusList)

// @ApiModelProperty("发票性质 RED/BLUE")
// private InvoiceNatureEnum invoiceNature;
const invoiceNatureList = [
  {
    label: '红票',
    value: 'RED',
  },
  {
    label: '蓝票',
    value: 'BLUE',
  },
] as const

export type InvoiceNatureValue = ValueOf<typeof invoiceNatureList>
export const invoiceNatureEnum = customCreateEnum(invoiceNatureList)

// 红票开票状态
const redInvoiceStateList = [
  { label: '审核中', value: '1' },
  { label: '暂存', value: '2' },
  { label: '已开票', value: '3' },
  { label: '驳回', value: '4' },
  { label: '未开票', value: '5' },
] as const

export const redInvoiceStateEnum = customCreateEnum(redInvoiceStateList)

// 单选框，值范围：咸亨国际科技股份有限公司、万聚国际（杭州）供应链有限公司

const titleOfTheContractList = [
  { label: '咸亨国际科技股份有限公司', value: '1000' },
  {
    label: '万聚国际（杭州）供应链有限公司',
    value: '1025',
  },
] as const

export const titleOfTheContractEnum = customCreateEnum(titleOfTheContractList)
